package br.com.texeratx.boardgametimeapp.ui.screens.games.create

import br.com.texeratx.boardgametimeapp.ui.screens.games.model.CatalogGameUI
import br.com.texeratx.boardgametimeapp.ui.screens.games.model.PlayerOwnerUI

data class CreateGameState(
    val catalogGameId: Long? = null,
    val catalogName: String = "",
    val catalogImageUrl: String? = null,
    val catalogMinPlayers: Int? = null,
    val catalogMaxPlayers: Int? = null,
    val catalogDuration: Int? = null,
    val catalogBggUrl: String? = null,

    val gameModeId: Long? = null,
    val gameCategoryId: Long? = null,
    val categories: List<br.com.texeratx.boardgametimeapp.ui.screens.games.model.GameCategoryUI> = emptyList(),
    val manualUrl: String = "",
    val spotifyUrl: String = "",

    val owners: List<PlayerOwnerUI> = emptyList(),
    val selectedOwners: List<PlayerOwnerUI> = emptyList(),
    val isLoadingOwners: Boolean = false,

    val showCatalogSearch: Boolean = false,
    val catalogQuery: String = "",
    val catalogResults: List<CatalogGameUI> = emptyList(),
    val isSearchingCatalog: Boolean = false,

    val isSaving: Boolean = false,
    val error: String? = null
)
